<template>
    <section class="areas" :id="$t('routes.services')" :ref="$t('routes.services')">
        <div class="sloth-container">
            <h2 class="section-title text-center">
                {{ $t('specialized.title') }}
            </h2>
            <div class="specialized-in">
                <SpecializedItem 
                    v-scroll-reveal="{ delay: 120 }"
                    v-for="(item, key) in services" :key="key"
                    :title="$t(item.title)"
                    :icon="item.icon"
                    :description="$t(item.description)"
                />
            </div>
        </div>
    </section>
</template>

<script>
    import SpecializedItem from '../items/SpecializedItem'
    export default {
        name: "OurServices",
        components: {
            SpecializedItem
        },
        props: {
            title: String,
            services: Array
        }
    }
</script>
